import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		label: {
			fontWeight: "bold"
		},
		noteLabel: {
			fontWeight: "bold"
		}
	} satisfies Record<string, CSSObject>);
};
